import { endOfWeek, format } from "date-fns";

export default function getDateRangeString(fromDate: Date, toDate: Date) {
  const differentMonths = fromDate.getMonth() !== toDate.getMonth();
  const differentYears = fromDate.getFullYear() !== toDate.getFullYear();
  const fromDateFormat = `${differentMonths ? "MMM" : "MMMM"} d${
    differentYears ? ", yyyy" : ""
  }`;
  const toDateFormat = `${differentMonths ? "MMM " : ""}d, yyyy`;
  return `${format(fromDate, fromDateFormat)} - ${format(
    endOfWeek(fromDate),
    toDateFormat
  )}`;
}
